/**
 * Scroll progress bar — 2px rust line pinned to the top of the viewport,
 * a vanilla port of paree.careV2's ScrollProgress.tsx so the shop and the
 * main site share the same signature detail.
 *
 * Same behaviour: rAF-throttled scaleX on scroll, 90ms linear transition,
 * hidden entirely under prefers-reduced-motion (decorative, not informational).
 * Injected into layout/theme.liquid by theme/apply-brand.mjs.
 */
;(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return

  var wrap = document.createElement('div')
  wrap.setAttribute('aria-hidden', 'true')
  wrap.style.cssText =
    'position:fixed;top:0;left:0;right:0;height:2px;z-index:60;pointer-events:none'

  var bar = document.createElement('div')
  bar.style.cssText =
    'height:100%;transform-origin:0 50%;transform:scaleX(0);' +
    'transition:transform 90ms linear;background:#9c4d35'
  wrap.appendChild(bar)
  document.body.appendChild(wrap)

  var ticking = false
  function update() {
    ticking = false
    var doc = document.documentElement
    var max = doc.scrollHeight - window.innerHeight
    var p = max > 0 ? Math.min(1, Math.max(0, window.scrollY / max)) : 0
    bar.style.transform = 'scaleX(' + p + ')'
  }
  function onScroll() {
    if (ticking) return
    ticking = true
    requestAnimationFrame(update)
  }

  update()
  window.addEventListener('scroll', onScroll, { passive: true })
  window.addEventListener('resize', onScroll)
})()
